class Expand extends HTMLElement {
  constructor() {
    super();
    this.toggleExpand = this.toggleExpand.bind(this);
  }
  connectedCallback() {
    this.expandEl = this;
    this.expandContent = this.expandEl.querySelector(".js-expand-content");
    this.expandButton = this.expandEl.querySelector(".js-expand-button");
    this.beforeExpandHeight = parseInt(this.expandEl.dataset.height);
    this.contentHeight = this.expandContent.offsetHeight;
    if (this.contentHeight > this.beforeExpandHeight) {
      this.expandEl.style.setProperty("--before-expand-height", `${parseInt(this.beforeExpandHeight)}px`);
      this.expandEl.style.setProperty("--expanded-height", `${parseInt(this.contentHeight)}px`);
      this.expandButton.addEventListener("click", this.toggleExpand);
    } else {
      this.expandButton.style.display = "none";
    }
  }
  toggleExpand() {
    this.expandEl.classList.toggle("expand--expanded");
  }
}
customElements.define("w3-expand", Expand);
